import { useEffect, useState } from "react";

const KEY = "pba_reader_settings";
const DEFAULT = {
  fontSize: 18,
  lineHeight: 1.75,
  maxWidth: 720,
  fontFamily: "'Spectral', serif",
};

export function useReaderSettings() {
  const [settings, _set] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) return { ...DEFAULT, ...JSON.parse(raw) };
    } catch { /* noop */ }
    return DEFAULT;
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(settings));
  }, [settings]);

  return [settings, _set];
}
